import {
  Component,
  HostListener,
  OnInit,
  inject,
  output,
  input
} from '@angular/core';
import { Router } from '@angular/router';
import { CheckOutReleaseObj, ComponentInstance } from 'src/app/models/enum';
import {
  CheckoutService,
  ReleaseSeatFromCartIn,
} from 'src/app/services/checkout.service';
import { CommonService } from 'src/app/services/common.service';
import { SwitchTicketService } from '../../switch-ticket/switch-service.service';
import { LocalizePipe } from 'src/app/pipes/localize.pipe';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-timeout-content',
  templateUrl: './timeout-content.component.html',
  styleUrls: ['./timeout-content.component.scss'],
  imports: [LocalizePipe, NgOptimizedImage],
})
export class TimeoutContentComponent implements OnInit {
  private router = inject(Router);
  private commonService = inject(CommonService);
  private checkoutService = inject(CheckoutService);
  private switchTicketService = inject(SwitchTicketService);

  showId = '';
  applicationId = '';
  isMembership: boolean = false;
  isClassPass: boolean = false;
  isSeasonPass: boolean = false;
  isClassPassFromLink: boolean = false;
  isWeeklyClassPass: boolean = false;
  isFestivalMode: boolean = false;
  isOpenSuperbFromAttendeeAPP: boolean = false;
  isGASeasonPass: boolean = false;
  /** Prevents the timer cleanup from firing more than once within this component's lifecycle. */
  private cleanupFired = false;
  readonly componentInstance = input<ComponentInstance>(ComponentInstance.Default);
  readonly navigateBackToCatalogSales = output<boolean>();
  readonly additionalOrderItems = input<number[]>([]);
  @HostListener('window:popstate', ['$event'])
  onPopState() {
    if (this.commonService.applicationId) {
      this.navigate(false);
    }
  }

  ngOnInit(): void {
    this.applicationId = this.commonService.getApplicationId();
    this.showId = this.commonService.getShowId();
    this.isMembership = this.commonService.isMembership;
    this.isSeasonPass = this.commonService.isSeasonPass;
    this.isGASeasonPass = this.commonService.isGASeasonPass;
    this.isClassPass = this.commonService.isClassPass;
    this.isClassPassFromLink = this.commonService.isClassPassFromLink;
    this.isWeeklyClassPass = this.commonService.isWeeklyClassPass;
    this.isFestivalMode = this.commonService.isFestivalMode;
    this.isOpenSuperbFromAttendeeAPP =
      this.commonService.isOpenSuperbFromAttendeeAPP;
    this.commonService.resetOrderOnTimeout = true;
    this.commonService.timerTextGlobal = '';
    this.commonService.clearPromoPromptSession(this.showId);
    //Need to call this Function on Timout so the orderItem will be released From that orderIdentifier
    if (this.commonService.orderIdentifier) {
      if (
        this.commonService.isSwitchTicketForPeakDays &&
        this.isOpenSuperbFromAttendeeAPP
      ) {
        this.switchTicketService
          .removeSwitchTicketSectionFromCart(this.commonService.orderIdentifier)
          .subscribe();
      } else this.releaseTicketsFromCart();
    }
  }

  public releaseTicketsFromCart(): void {
    // Guard: prevent double-fire if this component is re-initialized within the same Angular
    // lifecycle (e.g. route re-render). The server-side dedup in ReleaseSeatFromCartTimer
    // provides an additional safety net for the keepalive-fetch second call.
    if (this.cleanupFired) return;
    this.cleanupFired = true;
    const checkOutReleaseObj: CheckOutReleaseObj = {
      orderIdentifier: this.commonService.orderIdentifier,
      additionalOrderItems: this.additionalOrderItems(),
    };
    this.checkoutService
      .releaseTicketsFromCart(checkOutReleaseObj, ReleaseSeatFromCartIn.Timer)
      .subscribe();
  }

  redirectHome(): void {
    this.navigate(true);
  }

  public get ComponentInstance() {
    return ComponentInstance;
  }

  private navigateToUrl(path: string, useRouter: boolean = false): void {
    if (useRouter) {
      if (this.isOpenSuperbFromAttendeeAPP) {
        this.router.navigate([path], {
          queryParams: {
            userid: this.commonService.flutterAppLoggedInUserId,
            smtxorigin: 2,
          },
        });
      } else {
        this.router.navigate([path]);
      }
    } else {
      window.location.href = path;
    }
  }

  private navigate(isRouter: boolean = false) {
    const { applicationId, showId } = this.isMembership
      ? this.commonService
      : this;
    if (this.isMembership && !this.isOpenSuperbFromAttendeeAPP) {
      this.navigateToUrl(`/m/${applicationId}/${showId}`, isRouter);
    } else if (
      (this.isSeasonPass || this.isGASeasonPass) &&
      !this.isOpenSuperbFromAttendeeAPP
    ) {
      this.navigateToUrl(`/s/${applicationId}/${showId}`, isRouter);
    } else if (
      this.isClassPass &&
      !this.isClassPassFromLink &&
      !this.isWeeklyClassPass &&
      !this.isFestivalMode
    ) {
      this.navigateToUrl(`/c/${applicationId}/${showId}`, isRouter);
    } else if (
      this.isClassPass &&
      !this.isClassPassFromLink &&
      !this.isWeeklyClassPass &&
      this.isFestivalMode
    ) {
      this.navigateToUrl(`/f/${applicationId}/${showId}`, isRouter);
    } else if (this.isClassPass && this.isWeeklyClassPass) {
      this.navigateToUrl(`/w/${applicationId}/${showId}`, isRouter);
    } else if (this.isOpenSuperbFromAttendeeAPP) {
      this.navigateToUrl(`/multi-event/${applicationId}/0`, isRouter);
    } else if (
      this.componentInstance() === ComponentInstance.SquareCatalogComponent
    ) {
      this.navigateBackToCatalogSales.emit(true);
    } else {
      this.navigateToUrl(`/${applicationId}/${showId}`, isRouter);
    }
  }
}
